import { WifiOff } from 'lucide-react'

interface PhoneFrameErrorStateProps {
  /** True when storefront URL is missing (not a load failure) */
  isNoStore?: boolean
  onRetry?: () => void
}

/**
 * Error state for the phone frame preview.
 * Two variants: load failure (with retry) and missing storefront URL (no retry).
 */
export function PhoneFrameErrorState({ isNoStore, onRetry }: PhoneFrameErrorStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 px-6 text-center">
      <WifiOff className="h-8 w-8 text-gray-300" />
      <p className="text-xs text-gray-500">
        {isNoStore
          ? 'ร้านค้ายังไม่พร้อม'
          : 'ไม่สามารถโหลดตัวอย่างได้'}
      </p>
      {!isNoStore && onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="rounded-xs border border-gray-300 px-3 py-1.5 text-xs text-gray-600 transition-colors motion-reduce:transition-none hover:bg-gray-50 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
        >
          ลองใหม่
        </button>
      )}
    </div>
  )
}
